export const isShiftPlanEnabled = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) return false;

  try {
    const parts = token.split("|").map((p) => p.trim());

    if (parts.length < 2) return false;

    const flag = parts[parts.length - 2];

    return flag !== "1";
  } catch (err) {
    console.error("Error parsing token for shift plan:", err);
    return false;
  }
};
